/**
 * Volgt klantbriefings waarvan de AI-check nog loopt (analyse_status 'bezig').
 *
 * De engine bewaart meteen en analyseert op de achtergrond (28 sep); wij vragen de
 * bestaande GET elke `interval` ms opnieuw op, hooguit `maxDuur` ms. Een briefing
 * die van 'bezig' naar iets anders gaat, meldt zich via onKlaar (klaar óf mislukt).
 * Geeft een stop-functie terug.
 */
export function volgBriefingChecks({
  haalOp, ids, interval = 5000, maxDuur = 180000,
  onResultaat, onKlaar, onTimeout, onEinde,
}) {
  let gestopt = false;
  let timer = null;
  let rondes = 0;
  const maxRondes = Math.max(1, Math.ceil(maxDuur / interval));
  const open = new Set(ids || []);

  const einde = () => { if (!gestopt) { gestopt = true; onEinde?.(); } };

  const ronde = async () => {
    if (gestopt) return;
    rondes += 1;
    let docs = null;
    try { docs = await haalOp(); } catch { docs = null; }
    if (gestopt) return;
    if (Array.isArray(docs)) {
      onResultaat?.(docs);
      docs.forEach((d) => {
        // Nieuw bijgekomen 'bezig'-briefings (tweede upload tijdens het wachten) ook volgen.
        if (d.analyse_status === 'bezig') open.add(d.id);
      });
      [...open].forEach((id) => {
        const doc = docs.find((d) => d.id === id);
        if (!doc) { open.delete(id); return; } // intussen verwijderd
        if (doc.analyse_status !== 'bezig') { open.delete(id); onKlaar?.(doc); }
      });
    }
    if (!open.size) { einde(); return; }
    if (rondes >= maxRondes) { onTimeout?.([...open]); einde(); return; }
    timer = setTimeout(ronde, interval);
  };

  if (!open.size) { einde(); return () => {}; }
  timer = setTimeout(ronde, interval);
  return () => { clearTimeout(timer); einde(); };
}
